import React, { useEffect, useState } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { useNotification } from '../hooks/useNotification';
import NotificationContainer from './noticeCard/NotificationContainer';
import { NotificationData, NotificationType } from './noticeCard/NotificationMapper';

// 定义WebSocket消息接口
interface WSMessage {
  type: string;
  data?: any;
  timestamp: number;
  message_id?: string;
}

const WebSocketNotification: React.FC = () => {
  const { showNotification } = useNotification();
  const [notifications, setNotifications] = useState<NotificationData[]>([]);
  
  // 使用WebSocket Hook，确保处理在线状态
  const { messages, isConnected } = useWebSocket({
    url: (process.env.REACT_APP_WS_BASE_URL || 'ws://localhost:8000') + '/api/v1/agent/ws/home/index/notification',
    autoConnect: true,
    debug: false,
    handleOnlineStatus: true // 确保处理在线状态消息
  });

  // 监听WebSocket消息
  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
      
      // 只处理接收到的消息
      if (lastMessage.type === 'received') {
        handleWebSocketMessage(lastMessage.content);
      }
    }
  }, [messages]);

  // 处理WebSocket消息
  const handleWebSocketMessage = (message: WSMessage) => {
    // 如果是通知类型的消息
    if (message.type === 'notification' && message.data) {
      const notificationData = message.data as NotificationData;
      
      // 添加时间戳
      const enhancedNotification: NotificationData = {
        ...notificationData,
        timestamp: new Date().toISOString(),
      };
      
      // 添加到通知列表
      setNotifications(prev => [...prev, enhancedNotification]);
      
      // 触发通知hook（保持兼容性）
      showNotification();
    }
  };

  // 处理通知关闭
  const handleNotificationClose = (notificationId: string) => {
    setNotifications(prev => 
      prev.filter(notification => notification.notification_id !== notificationId)
    );
  };

  // 渲染通知容器
  return (
    <NotificationContainer
      notifications={notifications}
      position="top-right"
      maxNotifications={5}
      autoClose={true}
      autoCloseDelay={5000}
      onNotificationClose={handleNotificationClose}
    />
  );
};

export default WebSocketNotification;